interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "center" | "left";
}

export default function SectionHeading({ eyebrow, title, description, align = "center" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start text-left"}`}>
      <span className="inline-flex items-center gap-3 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
        <span className="w-6 h-px bg-primary-400"></span>
        {eyebrow}
        <span className="w-6 h-px bg-primary-400"></span>
      </span>
      <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">{title}</h2>
      {description && (
        <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">{description}</p>
      )}
    </div>
  );
}